import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { LANGUAGES, langFromPath } from "./seo/lang";
export const MyLanguages = [
  { label: "English", code: "gb" },
  { label: "Deutsch", code: "de" },
  { label: "Français", code: "fr" },
  { label: "Italiano", code: "it" },
];
export function GetInitialLanguage() {
  return MyLanguages.find((lang) => lang.code === i18n.language) || MyLanguages[0];
}
const version = new Date().getTime();
i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // The URL decides the language (seo/lang.ts), so there is no detector: a stored
    // or browser language only matters for the one-time redirect in LanguageContext.
    lng: langFromPath(window.location.pathname).code,
    supportedLngs: LANGUAGES.map((lang) => lang.code),
    debug: false,
    fallbackLng: "gb",
    // keySeparator: false,
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${version}`,
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
